import type { ClassValue } from 'clsx/lite';
import { clsx } from 'clsx/lite';
import { twMerge } from 'tailwind-merge';

const cn = (...inputs: ClassValue[]) => twMerge(clsx(...inputs));

export default cn;
